module.exports = __webpack_public_path__ + "static/media/logo-conlicita-branca.d11c0b7a.svg";